import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as OTPVerified } from "../../../Assets/Images/otpVerified.svg";
import { DataContext } from '../../../Components/DataContext.js';
import AppTracking from "../../../Components/appTracking";

const AmountCredited = () => {
  const { data } = useContext(DataContext);
  const newData = { ...data };
  const navigate = useNavigate();
  useEffect(() => {
    if (newData.token === null) {
      navigate('/')
    }
    else if (newData.transactionStatus === false) {
      navigate('/dashboard');
    }
    else {
      setTimeout(() => {
        navigate('/dashboard');
      }, 10000);
    }
  })

  return (
    <>
      <AppTracking pageName={window.location.pathname.replace(/\//g, '')} />
      <div className="content-wrapper responsive-wrapper">
        <div>
          <img
            src={require('../../../Assets/Images/WS2k2.gif')}
            className='sparkle' />
        </div>
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 m-auto">
            <div className="DarkPanel">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <OTPVerified />
              </div>
            </div>
            <div className="row mt-3 mb-4">
              <div className="col-lg-12 col-md-12 col-sm-12 mb-3 mt-3">
                <div className="redeemPanel">
                  <h3>₹{newData.scanVal}</h3>
                  <p>
                    has been redeemed
                    <span>Succesfully</span>
                  </p>
                </div>
              </div>
            </div>
            <div className="row mt-5 pt-5">
              <div className="col-lg-12 col-md-12 col-sm-12 Redirect-panel pt-5">
                <p>
                  If you are not redirected automatically, please{" "}
                  <a onClick={() => navigate('/dashboard')}> Click Here</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AmountCredited;
